import { defineComponent } from 'vue';
import UserTableComponent from '@/components/userTable/UserTable.vue';

export default defineComponent({
  name: 'UserPage',
  components: {
    UserTableComponent
  },
});
